import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Language = 'en' | 'fr';

interface LanguageState {
  language: Language;
}

const initialState: LanguageState = {
  language: 'en',
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer; 